/** The modeller's Excel as Office reports it (`Office.context.diagnostics.platform`: `Mac`, `PC`, `OfficeOnline`…),
 *  sent with every turn's context so that the steps the server gives name that Excel's menus (sculpt-api
 *  PLAN-paste-loops.md, decision 34). Null outside Office, or when Office does not say. */
export function officePlatform(): string | null {
  try {
    const office = (globalThis as { Office?: { context?: { diagnostics?: { platform?: unknown } } } }).Office;
    const platform = office?.context?.diagnostics?.platform;
    return platform ? String(platform) : null;
  } catch {
    return null;
  }
}
